import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $isTableNode } from "@lexical/table";
import { $getSelection, $isRangeSelection } from "lexical";
import { useEffect } from "react";
import { $isDataTableNode } from "../../../nodes/data-table-node";

export const useShowGridLines = (): void => {
  const [editor] = useLexicalComposerContext();

  // Since Lexical 0.52 SELECTION_CHANGE_COMMAND runs before reconciliation, when the previous
  // selection can point at nodes the pending update has removed. Read the committed state instead.
  useEffect(() => {
    let shown = new Set<HTMLElement>();
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        const next = new Set<HTMLElement>();
        if ($isRangeSelection(selection)) {
          for (const parent of selection.anchor.getNode().getParents()) {
            if (!$isTableNode(parent) || $isDataTableNode(parent)) continue;
            const element = editor.getElementByKey(parent.getKey());
            if (element) next.add(element);
          }
        }
        for (const element of shown) {
          if (!next.has(element)) element.classList.remove("show-grid-lines");
        }
        for (const element of next) element.classList.add("show-grid-lines");
        shown = next;
      });
    });
  }, [editor]);
};
